/* eslint-disable */
/*eslint no-magic-numbers: ["error", { "ignore": [0] }]*/
import React, { useState, useContext, useEffect } from 'react'
import { useParams } from 'react-router-dom'

import Container from 'components/Container'
import Row from 'components/Row'
import Col from 'components/Col'
import Input from 'components/Input'
import Textarea from 'components/Textarea'
import Select from 'components/Select'
import MultiSelectionDropdown from 'components/MultiSelectDropdown'
import ecoSystem from 'constants/ecoSystem'
import siteCoverage from 'constants/siteCoverage'
import { CountriesContext } from 'providers/countries'
import { SiteContext } from 'providers/site'
import { delay } from 'utils/delay'
import { SITE_STATUS_CONFIRMED_ID, SITE_STATUS_DELISTED_ID, SITE_STATUS_DRAFT_ID, SITE_STATUS_SUPERSEDED_ID, SITE_STATUS_EDIT_ONLY_ID, SITE_STATUS_SUBMITTED_EDIT_ONLY_ID } from 'constants/siteStatuses'
import oecmOverlap from 'constants/oecmOverlap'
import { requestUpdateSite, requestUpdateEditOnlySite } from 'api/site'
import { isValidDecimalNumber, noZeroAfterDecimal } from 'utils/isValidDecimalNumber'
import { minMaxValidation } from 'utils/minBestMaxValidation'
import ScrollToTop from 'components/ScrollToTop'
import AssessmentTitle from 'components/AssessmentTitle'
import formatNum2Dp from 'utils/formatNum2DP'
import formatNum4Dp from 'utils/formatNum4DP'
import Habitats from './Habitats/Components/Habitats'
import addGraphicsToKBALayer from 'utils/addGraphicsToKBALayer'
import { requestGetCurrentSiteGeometry, requestGetDraftSiteGeometry } from 'api/site'
import Graphic from '@arcgis/core/Graphic'
import { ProfileContext } from 'providers/profile'
import { INDIVIDUAL_ROLE_ID, NCG_ROLE_ID } from 'constants/roles'

const minMaxFields = {
  min: 'minimumDepth',
  max: 'maximumDepth'
}

const minMaxAltFields = {
  min: 'lowestAltitude',
  max: 'highestAltitude'
}

const inputSaveDelayTime = 300
const updateSiteNameTimeout = delay(inputSaveDelayTime)
const updateSiteNameNationalTimeout = delay(inputSaveDelayTime)
const updateStateChange = delay(inputSaveDelayTime)
const updateSiteAreaTimeout = delay(inputSaveDelayTime)
const updateLatitudeOfMidPointTimeout = delay(inputSaveDelayTime)
const updateLongitudeOfMidPointTimeout = delay(inputSaveDelayTime)
const updateRationaleForSiteInformationTimeout = delay(inputSaveDelayTime)
const updateSiteDescriptionTimeout = delay(inputSaveDelayTime)
const updateHowIsTheSiteManagedTimeout = delay(inputSaveDelayTime)
const updateDeliniationRationaleTimeout = delay(inputSaveDelayTime)
const updateCoveredByWhatProtectedAreasTimeout = delay(inputSaveDelayTime)
const updateBiodiversadditionalBiodiversityValuesityValuesTimeout = delay(inputSaveDelayTime)
const updateLandUseRegimesAtSiteTimeout = delay(inputSaveDelayTime)
const updateNotesTimeout = delay(inputSaveDelayTime)
const updateIndigenousGroupsTimeout = delay(inputSaveDelayTime)
const updateThreatsDescriptionValuesTimeout = delay(inputSaveDelayTime)
const updateMaximumDepthValuesTimeout = delay(inputSaveDelayTime)
const updateSupersededValuesTimeout = delay(inputSaveDelayTime)
const updateCoveredByPaValuesTimeout = delay(inputSaveDelayTime)
const updateCoveredByOECMValuesTimeout = delay(inputSaveDelayTime)
const updateHabitatTimeout = delay(inputSaveDelayTime)
const updateReferencessTimeout = delay(inputSaveDelayTime)
const contributorsSavetimeout = delay(inputSaveDelayTime)
const DetailsPage = () => {
  const { site, siteProposalFieldValidation, isEditable } = useContext(SiteContext)
  const { profile } = useContext(ProfileContext)
  const { countriesOptions } = useContext(CountriesContext)
  const params = useParams()

  if (!site.id) {
    return null
  }
  const editOnlySiteStatus = site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID || site.SiteStatusId === SITE_STATUS_SUBMITTED_EDIT_ONLY_ID

  const disabledBtn = site.SiteStatusId !== SITE_STATUS_DRAFT_ID || (!isEditable && site.SiteStatusId === SITE_STATUS_DRAFT_ID)
  const isEditOnlyEnabledBtn =
    (site.SiteStatusId !== SITE_STATUS_DRAFT_ID && site.SiteStatusId !== SITE_STATUS_EDIT_ONLY_ID)
    ||
    (isEditable && (site.SiteStatusId === SITE_STATUS_DRAFT_ID || site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID))
    ||
    (!isEditable && site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID && (profile.RoleId !== INDIVIDUAL_ROLE_ID && profile.RoleId !== NCG_ROLE_ID));

  const disabled = editOnlySiteStatus ? isEditOnlyEnabledBtn : disabledBtn;

  const initialEcoSystemId =
    ecoSystem.find((option) => {
      return option.value === site.EcoSystemsId
    }) || null
  const initialEcoSystems2LargestId =
    ecoSystem.find((option) => {
      return option.value === site.EcoSystems2LargestId
    }) || null
  const initialEcoSystems3LargestId =
    ecoSystem.find((option) => {
      return option.value === site.EcoSystems3LargestId
    }) || null
  const initialEcoSystemsSmallestId =
    ecoSystem.find((option) => {
      return option.value === site.EcoSystemsSmallestId
    }) || null
  const initialCoverageOfProtectedAreasId =
    siteCoverage.find((option) => {
      return option.value === site.CoverageOfProtectedAreasId
    }) || null
  const initialOECMOverlap =
    oecmOverlap.find((element) => {
      return element.value === site.overlapOECMProtectedCoverage
    }) || null

  const [name, setName] = useState(site.name || '')
  const [siteNameNational, setSiteNameNational] = useState(site.siteNameNational || '')
  const [CountryCode, setCountryCode] = useState(site.SiteDetailsCountryId)
  const [state, setState] = useState(site.state || '')
  const [siteArea, setSiteArea] = useState(site.siteArea ? formatNum2Dp(site.siteArea) : '')
  const [latitudeOfMidPoint, setLatitudeOfMidPoint] = useState(site.latitudeOfMidPoint ? formatNum4Dp(site.latitudeOfMidPoint) : '')
  const [longitudeOfMidPoint, setLongitudeOfMidPoint] = useState(site.longitudeOfMidPoint ? formatNum4Dp(site.longitudeOfMidPoint) : '')
  const [highestAltitude, setHighestAltitude] = useState(site.highestAltitude !== null && site.highestAltitude !== undefined ? formatNum2Dp(site.highestAltitude) : '');
  const [lowestAltitude, setLowestAltitude] = useState(site.lowestAltitude !== null && site.lowestAltitude !== undefined ? formatNum2Dp(site.lowestAltitude) : '');
  const [minimumDepth, setMinimumDepth] = useState(site.minDepth !== null && site.minDepth !== undefined ? formatNum2Dp(site.minDepth) : '');
  const [maximumDepth, setMaximumDepth] = useState(site.maxDepth !== null && site.maxDepth !== undefined ? formatNum2Dp(site.maxDepth) : '');
  const [depthError, setDepthError] = useState({ field: '', error: '' })
  const [altitudeError, setAltitudeError] = useState({ field: '', error: '' })
  const [EcoSystemsId, setEcoSystemsId] = useState(initialEcoSystemId)
  const [EcoSystems2LargestId, setEcoSystems2LargestId] = useState(initialEcoSystems2LargestId)
  const [EcoSystems3LargestId, setEcoSystems3LargestId] = useState(initialEcoSystems3LargestId)
  const [EcoSystemsSmallestId, setEcoSystemsSmallestId] = useState(initialEcoSystemsSmallestId)
  const [rationaleForSiteInformation, setRationaleForSiteInformation] = useState(site.rationaleForSiteInformation || '')
  const [siteDescription, setSiteDescription] = useState(site.siteDescription || '')
  const [howIsTheSiteManaged, setHowIsTheSiteManaged] = useState(site.howIsTheSiteManaged || '')
  const [deliniationRationale, setDeliniationRationale] = useState(site.deliniationRationale || '')
  const [CoverageOfProtectedAreasId, setCoverageOfProtectedAreasId] = useState(initialCoverageOfProtectedAreasId)
  const [coveredByWhatProtectedAreas, setCoveredByWhatProtectedAreas] = useState(site.coveredByWhatProtectedAreas || '')
  const [biodiversadditionalBiodiversityValuesityValues, setBiodiversadditionalBiodiversityValuesityValues] = useState(
    site.additionalBiodiversityValues || ''
  )
  const [landUseRegimesAtSite, setLandUseRegimesAtSite] = useState(site.landUseRegimesAtSite || '')
  const [coveredByPa, setCoveredByPa] = useState(site.calculatedProtectedArea ? formatNum2Dp(site.calculatedProtectedArea) : '')
  const [coveredByOECM, setCoveredByOECM] = useState(site.calculatedOECMArea ? formatNum2Dp(site.calculatedOECMArea) : '')
  const [threatsDescription, setThreatsDescription] = useState(site.threatsDescription || '')
  const [supersidedSites, setSupersidedSites] = useState(site.supersededSitesDesription || '')
  const [notes, setNotes] = useState(site.notes || '')
  const [habitat, setHabitat] = useState(site.habitatDescription || '')
  const [indigenousGroups, setIndigenousGroups] = useState(site.indigenousGroups || '')
  const [oecmDrop, setOecmDrop] = useState(initialOECMOverlap)
  const [references, setReferences] = useState(site.references || '')
  const [contributors, setContributors] = useState(site.consultationWithContributors || '')
  const [countryInput, setCountryInput] = useState('')

  const historyId = editOnlySiteStatus ? site.historyId : params.siteHistoryId

  useEffect(() => {
    const fetchBoundaryGeometry = async () => {
      try {
        const ignoreDraftSiteGeometry = [SITE_STATUS_CONFIRMED_ID, SITE_STATUS_DELISTED_ID, SITE_STATUS_SUPERSEDED_ID].includes(site.SiteStatusId)
        let geometryResults;

        if (ignoreDraftSiteGeometry) {
          geometryResults = await requestGetCurrentSiteGeometry(params.id, historyId);
        } else {
          geometryResults = await requestGetDraftSiteGeometry(params.id, historyId);

          // If no draft geometry is found and it's a reassessment, fetch from the confirmed layer
          if ((!geometryResults?.features?.length) && isReassessment) {
            geometryResults = await requestGetCurrentSiteGeometry(params.id, historyId);
          }
        }

        const { features } = geometryResults
        if (features.length > 1) {
          console.error('Found multiple features with the same "siterecid"; using first feature found.')
        }
        const foundFeature = features[0]
        const geometry = {
          ...foundFeature.geometry,
          type: 'polygon',
          spatialReference: geometryResults.spatialReference
        }
        const newGraphic = new Graphic({
          geometry: geometry,
          attributes: foundFeature.attributes,
          symbol: {
            type: 'simple-fill',
            color: [150, 150, 150, 0.15],
            outline: { width: 2, color: [0, 75, 150] }
          }
        })

        if (site.SiteStatusId === SITE_STATUS_DRAFT_ID) addGraphicsToKBALayer([newGraphic], params)
      } catch (error) {
        console.error("Error fetching boundary geometry:", error)
      }
    }

    if (site.id) fetchBoundaryGeometry()
  }, [params.id, params.siteHistoryId, site.id, site.SiteStatusId])

  // site gets refreshed once the MapPage closes, so make sure any changes it makes
  // to site update the values in this page:
  useEffect(() => {
    setSiteArea(site.siteArea)
    setLatitudeOfMidPoint(site.latitudeOfMidPoint)
    setLongitudeOfMidPoint(site.longitudeOfMidPoint)
  }, [site])

  const isNumber = (val) => {
    return typeof val === 'number' && isFinite(val)
  }

  const maxSixDPs = (val) => {
    const dps = val.substr(val.indexOf('.'))
    if (dps.length > '127') {
      return false
    }
    return true
  }

  const handleSearchCountry = (e) => {
    setCountryInput(e)
  }

  const handleChangeOecm = async (e) => {
    setOecmDrop(e);
    const data = { overlapOECMProtectedCoverage: e.value };

    if (site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID) {
      await requestUpdateEditOnlySite(site.id, data);
    } else {
      await requestUpdateSite(params.id, historyId, data);
    }
  };

  const handleNameChange = async (e) => {
    setName(e.target.value);
    await updateSiteNameTimeout(async () => {
      const data = { name: e.target.value };

      if (site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID) {
        await requestUpdateEditOnlySite(site.id, data);
      } else {
        await requestUpdateSite(params.id, historyId, data);
      }
    });
  };

  const handleIndigenousGroupsChange = async (e) => {
    setIndigenousGroups(e.target.value);

    await updateIndigenousGroupsTimeout(async () => {
      const data = { indigenousGroups: e.target.value };

      if (site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID && site.sitehistoryId) {
        await requestUpdateEditOnlySite(site.id, data);
      } else {
        await requestUpdateSite(site.id, historyId, data);
      }
    });
  };

  const handleSiteNationalNameChange = async (e) => {
    setSiteNameNational(e.target.value);
    await updateSiteNameNationalTimeout(async () => {
      const data = { siteNameNational: e.target.value };

      if (site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID) {
        await requestUpdateEditOnlySite(site.id, data);
      } else {
        await requestUpdateSite(params.id, params.siteHistoryId, data);
      }
    });
  };

  const handleCountryChange = async (e) => {
    setCountryCode(e);
    const data = { SiteDetailsCountryId: e };

    if (site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID) {
      await requestUpdateEditOnlySite(site.id, data);
    } else {
      await requestUpdateSite(params.id, params.siteHistoryId, data);
    }
  };

  const handleStateChange = async (e) => {
    setState(e.target.value);
    await updateStateChange(async () => {
      const data = { state: e.target.value };

      if (site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID) {
        await requestUpdateEditOnlySite(site.id, data);
      } else {
        await requestUpdateSite(params.id, params.siteHistoryId, data);
      }
    });
  };

  const handleAreaChange = async (e) => {
    if (isNumber(Number(e.target.value)) && maxSixDPs(e.target.value)) {
      setSiteArea(e.target.value);
    }
    await updateSiteAreaTimeout(async () => {
      const data = { siteArea: e.target.value === '' ? null : Number(e.target.value).toFixed(10) };

      if (site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID) {
        await requestUpdateEditOnlySite(site.id, data);
      } else {
        await requestUpdateSite(params.id, historyId, data);
      }
    });
  };

  const handleLatitudeChange = async (e) => {
    if (isNumber(Number(e.target.value)) && maxSixDPs(e.target.value)) {
      setLatitudeOfMidPoint(e.target.value);
    }
    await updateLatitudeOfMidPointTimeout(async () => {
      const data = { latitudeOfMidPoint: e.target.value === '' ? null : Number(e.target.value).toFixed(10) };

      if (site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID) {
        await requestUpdateEditOnlySite(site.id, data);
      } else {
        await requestUpdateSite(params.id, historyId, data);
      }
    });
  };

  const handleLongitudeChange = async (e) => {
    if (isNumber(Number(e.target.value)) && maxSixDPs(e.target.value)) {
      setLongitudeOfMidPoint(e.target.value);
    }
    await updateLongitudeOfMidPointTimeout(async () => {
      const data = { longitudeOfMidPoint: e.target.value === '' ? null : Number(e.target.value).toFixed(10) };

      if (site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID) {
        await requestUpdateEditOnlySite(site.id, data);
      } else {
        await requestUpdateSite(params.id, historyId, data);
      }
    });
  };

  const handleHighestAltitudeChange = async (e) => {
    const errorMessage = minMaxValidation(lowestAltitude, e.target.value, minMaxAltFields, 'max');
    if (errorMessage.field === '') {
      if (isValidDecimalNumber(Number(e.target.value))) {
        setHighestAltitude(e.target.value);
        setAltitudeError(errorMessage);
        const value = Number(parseFloat(e.target.value).toFixed(10));
        const data = { highestAltitude: e.target.value === '' ? null : value };

        if (site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID) {
          await requestUpdateEditOnlySite(site.id, data);
        } else {
          await requestUpdateSite(params.id, historyId, data);
        }
      }
      return;
    }
    if (isValidDecimalNumber(Number(e.target.value))) {
      if (noZeroAfterDecimal(e.target.value)) {
        setHighestAltitude(e.target.value);
        setAltitudeError(errorMessage);
      }
    }
  };

  const handleLowestAltitudeChange = async (e) => {
    const errorMessage = minMaxValidation(e.target.value, highestAltitude, minMaxAltFields, 'min');
    if (errorMessage.field === '') {
      if (isValidDecimalNumber(Number(e.target.value))) {
        if (noZeroAfterDecimal(e.target.value)) {
          setLowestAltitude(e.target.value);
          setAltitudeError(errorMessage);
        }
        const value = Number(parseFloat(e.target.value).toFixed(10));
        const data = { lowestAltitude: e.target.value === '' ? null : value };

        if (site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID) {
          await requestUpdateEditOnlySite(site.id, data);
        } else {
          await requestUpdateSite(params.id, historyId, data);
        }
      }
      return;
    }
    if (isValidDecimalNumber(Number(e.target.value))) {
      if (noZeroAfterDecimal(e.target.value)) {
        setLowestAltitude(e.target.value);
        setAltitudeError(errorMessage);
      }
    }
  };

  const handleMinimumDepthChange = async (e) => {
    const errorMessage = minMaxValidation(e.target.value, maximumDepth, minMaxFields, 'min');
    if (errorMessage.field === '') {
      if (isValidDecimalNumber(Number(e.target.value))) {
        if (noZeroAfterDecimal(e.target.value)) {
          setMinimumDepth(e.target.value);
          setDepthError(errorMessage);
        }
        const value = Number(parseFloat(e.target.value).toFixed(10));
        const data = { minDepth: e.target.value === '' ? null : value };

        if (site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID) {
          await requestUpdateEditOnlySite(site.id, data);
        } else {
          await requestUpdateSite(params.id, historyId, data);
        }
      }
      return;
    }
    if (isValidDecimalNumber(Number(e.target.value))) {
      if (noZeroAfterDecimal(e.target.value)) {
        setMinimumDepth(e.target.value);
        setDepthError(errorMessage);
      }
    }
  };

  const handleMaximumDepthChange = async (e) => {
    const errorMessage = minMaxValidation(minimumDepth, e.target.value, minMaxFields, 'max');
    if (errorMessage.field === '') {
      if (isValidDecimalNumber(Number(e.target.value))) {
        if (noZeroAfterDecimal(e.target.value)) {
          setMaximumDepth(e.target.value);
          setDepthError(errorMessage);
        }
        const value = Number(parseFloat(e.target.value).toFixed(10));
        const data = { maxDepth: e.target.value === '' ? null : value };

        await updateMaximumDepthValuesTimeout(async () => {
          if (site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID) {
            await requestUpdateEditOnlySite(site.id, data);
          } else {
            await requestUpdateSite(params.id, historyId, data);
          }
        });
      }
      return;
    }
    if (isValidDecimalNumber(Number(e.target.value))) {
      if (noZeroAfterDecimal(e.target.value)) {
        setMaximumDepth(e.target.value);
        setDepthError(errorMessage);
      }
    }
  };

  const handleLargestSystemChange = async (e) => {
    setEcoSystemsId(e);
    const data = { EcoSystemsId: e.value };

    if (site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID) {
      await requestUpdateEditOnlySite(site.id, data);
    } else {
      await requestUpdateSite(params.id, historyId, data);
    }
  };

  const handleSecondLargestSystemChange = async (e) => {
    setEcoSystems2LargestId(e);
    const data = { EcoSystems2LargestId: e.value };

    if (site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID) {
      await requestUpdateEditOnlySite(site.id, data);
    } else {
      await requestUpdateSite(params.id, historyId, data);
    }
  };

  const handleThirdLargestSystemChange = async (e) => {
    setEcoSystems3LargestId(e);
    const data = { EcoSystems3LargestId: e.value };

    if (site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID) {
      await requestUpdateEditOnlySite(site.id, data);
    } else {
      await requestUpdateSite(params.id, historyId, data);
    }
  };

  const handleSmallestSystemChange = async (e) => {
    setEcoSystemsSmallestId(e);
    const data = { EcoSystemsSmallestId: e.value };

    if (site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID) {
      await requestUpdateEditOnlySite(site.id, data);
    } else {
      await requestUpdateSite(params.id, historyId, data);
    }
  };

  const handleRationaleChange = async (e) => {
    setRationaleForSiteInformation(e.target.value);
    await updateRationaleForSiteInformationTimeout(async () => {
      const data = { rationaleForSiteInformation: e.target.value };

      if (site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID) {
        await requestUpdateEditOnlySite(site.id, data);
      } else {
        await requestUpdateSite(params.id, historyId, data);
      }
    });
  };

  const handleDescriptionChange = async (e) => {
    setSiteDescription(e.target.value);

    await updateSiteDescriptionTimeout(async () => {
      const data = { siteDescription: e.target.value };

      if (site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID && site.sitehistoryId) {
        await requestUpdateEditOnlySite(site.id, data);
      } else {
        await requestUpdateSite(site.id,historyId, data);
      }
    });
  };

  const handleManagedChange = async (e) => {
    setHowIsTheSiteManaged(e.target.value);

    await updateHowIsTheSiteManagedTimeout(async () => {
      const data = { howIsTheSiteManaged: e.target.value };

      if (site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID && site.sitehistoryId) {
        await requestUpdateEditOnlySite(site.id, data);
      } else {
        await requestUpdateSite(site.id,historyId, data);
      }
    });
  };

  const handleSupersidedSitesChange = async (e) => {
    setSupersidedSites(e.target.value);

    await updateSupersededValuesTimeout(async () => {
      const data = { supersededSitesDesription: e.target.value };

      if (site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID && site.sitehistoryId) {
        await requestUpdateEditOnlySite(site.id, data);
      } else {
        await requestUpdateSite(site.id,historyId,data);
      }
    });
  };

  const handleDelineationChange = async (e) => {
    setDeliniationRationale(e.target.value);

    await updateDeliniationRationaleTimeout(async () => {
      const data = { deliniationRationale: e.target.value };

      if (site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID && site.sitehistoryId) {
        await requestUpdateEditOnlySite(site.id, data);
      } else {
        await requestUpdateSite(site.id,historyId, data);
      }
    });
  };

  const handleCoverageChange = async (e) => {
    setCoverageOfProtectedAreasId(e);
    const data = { CoverageOfProtectedAreasId: e.value };

    if (site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID) {
      await requestUpdateEditOnlySite(site.id, data);
    } else {
      await requestUpdateSite(params.id, historyId, data);
    }
  };

  const handleProtectedAreaChange = async (e) => {
    setCoveredByWhatProtectedAreas(e.target.value);
    await updateCoveredByWhatProtectedAreasTimeout(async () => {
      const data = { coveredByWhatProtectedAreas: e.target.value };

      if (site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID) {
        await requestUpdateEditOnlySite(site.id, data);
      } else {
        await requestUpdateSite(params.id, historyId, data);
      }
    });
  };

  const handleBiodiversityValuesChange = async (e) => {
    setBiodiversadditionalBiodiversityValuesityValues(e.target.value);

    await updateBiodiversadditionalBiodiversityValuesityValuesTimeout(async () => {
      const data = { additionalBiodiversityValues: e.target.value };

      if (site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID) {
        if (!site.historyId) {
          return;
        }
        await requestUpdateEditOnlySite(site.id, data);
      } else {
        await requestUpdateSite(site.id,historyId, data);
      }
    });
  };

  const handleLandUseChange = async (e) => {
    setLandUseRegimesAtSite(e.target.value);

    await updateLandUseRegimesAtSiteTimeout(async () => {
      const data = { landUseRegimesAtSite: e.target.value };

      if (site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID && site.sitehistoryId) {
        await requestUpdateEditOnlySite(site.id, data);
      } else {
        await requestUpdateSite(site.id,historyId, data);
      }
    });
  };

  const handleCoveredByPaChange = async (e) => {
    if (isNumber(Number(e.target.value)) && maxSixDPs(e.target.value)) {
      if (noZeroAfterDecimal(e.target.value)) {
        setCoveredByPa(e.target.value);
      }
      await updateCoveredByPaValuesTimeout(async () => {
        const data = { calculatedProtectedArea: Number(e.target.value).toFixed(10) };

        if (site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID) {
          await requestUpdateEditOnlySite(site.id, data);
        } else {
          await requestUpdateSite(params.id, historyId, data);
        }
      });
    }
  };

  const handleCoveredByOECMChange = async (e) => {
    if (isNumber(Number(e.target.value)) && maxSixDPs(e.target.value)) {
      if (noZeroAfterDecimal(e.target.value)) {
        setCoveredByOECM(e.target.value);
      }
      await updateCoveredByOECMValuesTimeout(async () => {
        const data = { calculatedOECMArea: Number(e.target.value).toFixed(10) };

        if (site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID) {
          await requestUpdateEditOnlySite(site.id, data);
        } else {
          await requestUpdateSite(params.id, historyId, data);
        }
      });
    }
  };

  const handleThreatsDescriptionChange = async (e) => {
    setThreatsDescription(e.target.value);

    await updateThreatsDescriptionValuesTimeout(async () => {
      const data = { threatsDescription: e.target.value };

      if (site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID && site.sitehistoryId) {
        await requestUpdateEditOnlySite(site.id, data);
      } else {
        await requestUpdateSite(site.id,historyId, data);
      }
    });
  };

  const handleNotesChange = async (e) => {
    setNotes(e.target.value);

    await updateNotesTimeout(async () => {
      const data = { notes: e.target.value };

      if (site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID && site.sitehistoryId) {
        await requestUpdateEditOnlySite(site.id, data);
      } else {
        await requestUpdateSite(site.id,historyId, data);
      }
    });
  };

  const handleReferencesChange = async (e) => {
    setReferences(e.target.value);

    await updateReferencessTimeout(async () => {
      const data = { references: e.target.value };

      if (site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID && site.sitehistoryId) {
        await requestUpdateEditOnlySite(site.id, data);
      } else {
        await requestUpdateSite(site.id,historyId, data);
      }
    });
  };

  const handleChangeContributors = async (e) => {
    setContributors(e.target.value);

    await contributorsSavetimeout(async () => {
      const data = { consultationWithContributors: e.target.value };

      if (site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID && site.sitehistoryId) {
        await requestUpdateEditOnlySite(site.id, data);
      } else {
        await requestUpdateSite(site.id,historyId, data);
      }
    });
  };

  const handleHabitatChange = async (e) => {
    setHabitat(e.target.value);
    await updateHabitatTimeout(async () => {
      const data = { habitatDescription: e.target.value };

      if (site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID) {
        await requestUpdateEditOnlySite(site.id, data);
      } else {
        await requestUpdateSite(params.id, historyId, data);
      }
    });
  };

  const second = 2

  return (
    <Container>
      <AssessmentTitle
        titleId='nameAndLocation'
        subTitleId='nameAndLocationDescription'
        fontSizePageSubtitle='14px'
      />
      <div data-test='site-name-location-form'>
        <Row>
          <Col md={8} mdOffset={2}>
            <Input
              value={site.siteCode}
              label='siteId'
              placeholder='noPlaceholder'
              infoTooltip='siteId'
              disabled={true}
            />
          </Col>
        </Row>
        <Row>
          <Col md={8} mdOffset={2}>
            <Input
              value={siteNameNational}
              onChange={handleSiteNationalNameChange}
              label='siteNameNational'
              field='siteNameNational'
              placeholder='nationalSiteName'
              dataTest='form-field'
              infoTooltip='siteNameNationalHint'
              disabled={disabled}
              error={
                siteProposalFieldValidation.details.siteNameNational
                  ? { field: '', error: '' }
                  : {
                    field: 'siteNameNational',
                    error: 'pleaseCompleteThisField'
                  }
              }
            />
          </Col>
        </Row>
        <Row>
          <Col md={8} mdOffset={2}>
            <Input
              value={name}
              onChange={handleNameChange}
              label='siteNameInternational'
              field='siteNameEnglish'
              placeholder='internationalSiteName'
              dataTest='form-field'
              infoTooltip='siteNameEnglishHint'
              disabled={disabled}
              error={
                siteProposalFieldValidation.details.name
                  ? { field: '', error: '' }
                  : {
                    field: 'siteNameEnglish',
                    error: 'pleaseCompleteThisField'
                  }
              }
            />
          </Col>
        </Row>
        <Row>
          <Col md={4} mdOffset={2}>
            <MultiSelectionDropdown
              marginTop='16px'
              label='countryLabel'
              field='siteDetailsCountry'
              secondStepOptions={countriesOptions}
              value={CountryCode}
              saveChanges={handleCountryChange}
              infoTooltip='countryHint'
              inputValue={countryInput}
              onInputChange={handleSearchCountry}
              // disabled={disabled}
              isSearchable={true}
              selectAllOption={true}
              error={
                siteProposalFieldValidation.details.SiteDetailsCountryId
                  ? { field: '', error: '' }
                  : {
                    field: 'siteDetailsCountry',
                    error: 'pleaseCompleteThisField'
                  }
              }
            />
          </Col>
          <Col md={4}>
            <Input
              value={state}
              onChange={handleStateChange}
              label='stateProvince'
              placeholder='stateProvincePlaceholder'
              dataTest='form-field'
              infoTooltip='stateProvinceHint'
              isOptional={true}
              disabled={disabled}
            />
          </Col>
        </Row>
      </div>
      <AssessmentTitle
        titleId='siteDetails'
        subTitleId='siteDetailsDescription'
        marginTop='64px'
        fontSizePageSubtitle='14px'
      />
      <div data-test='site-details-form'>
        <Row>
          <Col md={8} mdOffset={2}>
            <Textarea
              height='96px'
              label='siteDescription'
              field='siteDescription'
              value={siteDescription}
              onChange={handleDescriptionChange}
              placeholder='siteDescriptionPlaceholder'
              infoTooltip='siteDescriptionHint'
              disabled={disabled}
              error={
                siteProposalFieldValidation.details.siteDescription
                  ? { field: '', error: '' }
                  : {
                    field: 'siteDescription',
                    error: 'pleaseCompleteThisField'
                  }
              }
            />
          </Col>
        </Row>
        <Row>
          <Col md={4} mdOffset={2}>
            <Input
              label='siteArea'
              field='siteArea'
              value={siteArea}
              onChange={handleAreaChange}
              placeholder='siteAreaPlaceholder'
              dataTest='form-field'
              infoTooltip='siteAreaHint'
              disabled={disabled}
              isOptional={true}
            />
          </Col>
          <Col md={4}>
            <Input
              label='latitude'
              field='latitudeOfMidPoint'
              value={latitudeOfMidPoint}
              onChange={handleLatitudeChange}
              placeholder='latitudePlaceholder'
              dataTest='form-field'
              infoTooltip='latitudeOfCentroidHint'
              disabled={disabled}
              isOptional={true}
              type='number'
            />
          </Col>
        </Row>
        <Row>
          <Col md={4} mdOffset={2}>
            <Input
              label='longitude'
              field='longitudeOfMidPoint'
              value={longitudeOfMidPoint}
              onChange={handleLongitudeChange}
              placeholder='longitudePlaceholder'
              dataTest='form-field'
              infoTooltip='longitudeOfCentroidHint'
              disabled={disabled}
              isOptional={true}
              type='number'
            />
          </Col>
          <Col md={4}>
            <Input
              label='lowestElevation'
              field='lowestAltitude'
              value={lowestAltitude}
              onChange={handleLowestAltitudeChange}
              placeholder='lowestElevationPlaceholder'
              dataTest='form-field'
              infoTooltip='lowestElevationHint'
              type='number'
              disabled={disabled}
              error={
                siteProposalFieldValidation.details.lowestAltitude
                  ? altitudeError.field === 'lowestAltitude'
                    ? altitudeError
                    : { field: '', error: '' }
                  : {
                    field: 'lowestAltitude',
                    error: 'pleaseCompleteThisField'
                  }
              }
            />
          </Col>
        </Row>
        <Row>
          <Col md={4} mdOffset={2}>
            <Input
              label='highestElevation'
              field='highestAltitude'
              value={highestAltitude}
              onChange={handleHighestAltitudeChange}
              placeholder='highestElevationPlaceholder'
              dataTest='form-field'
              infoTooltip='highestElevationHint'
              type='number'
              disabled={disabled}
              error={
                siteProposalFieldValidation.details.highestAltitude
                  ? altitudeError.field === 'highestAltitude'
                    ? altitudeError
                    : { field: '', error: '' }
                  : {
                    field: 'highestAltitude',
                    error: 'pleaseCompleteThisField'
                  }
              }
            />
          </Col>
          <Col md={4}>
            <Input
              label='minimumDepth'
              field='minimumDepth'
              value={minimumDepth}
              onChange={handleMinimumDepthChange}
              placeholder='minimumDepthPlaceholder'
              dataTest='form-field'
              infoTooltip='minimumDepthHint'
              disabled={disabled}
              isOptional={true}
              error={
                depthError.field === 'minimumDepth'
                  ? depthError
                  : {
                    field: '',
                    error: ''
                  }
              }
            />
          </Col>
        </Row>
        <Row>
          <Col md={4} mdOffset={2}>
            <Input
              label='maximumDepth'
              field='maximumDepth'
              value={maximumDepth}
              onChange={handleMaximumDepthChange}
              placeholder='maximumDepthPlaceholder'
              dataTest='form-field'
              infoTooltip='maximumDepthHint'
              disabled={disabled}
              isOptional={true}
              error={
                depthError.field === 'maximumDepth'
                  ? depthError
                  : {
                    field: '',
                    error: ''
                  }
              }
            />
          </Col>
          <Col md={4}>
            <Select
              label='systemLargest'
              field='EcoSystemsId'
              options={ecoSystem}
              value={EcoSystemsId}
              onChange={handleLargestSystemChange}
              height='48px'
              placeholder='systemLargestPlaceholder'
              menuPlacement='bottom'
              dataTest='form-field'
              infoTooltip='systemHint'
              disabled={disabled}
              error={
                siteProposalFieldValidation.details.EcoSystemsId
                  ? { field: '', error: '' }
                  : {
                    field: 'EcoSystemsId',
                    error: 'pleaseCompleteThisField'
                  }
              }
            />
          </Col>
        </Row>
        <Row>
          <Col md={4} mdOffset={2}>
            <Select
              label='system2ndLargest'
              options={ecoSystem}
              value={EcoSystems2LargestId}
              onChange={handleSecondLargestSystemChange}
              height='48px'
              placeholder='secondLargestSystemPlaceholder'
              menuPlacement='bottom'
              dataTest='form-field'
              infoTooltip='systemHint'
              isOptional={true}
              disabled={disabled}
            />
          </Col>
          <Col md={4}>
            <Select
              label='system3rdLargest'
              options={ecoSystem}
              value={EcoSystems3LargestId}
              onChange={handleThirdLargestSystemChange}
              height='48px'
              placeholder='thirdLargestSystemPlaceholder'
              menuPlacement='bottom'
              dataTest='form-field'
              infoTooltip='systemHint'
              isOptional={true}
              disabled={disabled}
            />
          </Col>
        </Row>
        <Row>
          <Col md={8} mdOffset={2}>
            <Select
              label='systemSmallest'
              options={ecoSystem}
              value={EcoSystemsSmallestId}
              onChange={handleSmallestSystemChange}
              height='48px'
              placeholder='smallestSystemPlaceholder'
              menuPlacement='bottom'
              dataTest='form-field'
              infoTooltip='systemHint'
              isOptional={true}
              disabled={disabled}
            />
          </Col>
        </Row>
        <Row>
          <Col md={8} mdOffset={2}>
            <Textarea
              height='96px'
              label='rationale'
              field='rationaleForSiteInformation'
              value={rationaleForSiteInformation}
              onChange={handleRationaleChange}
              placeholder='rationalePlaceholder'
              infoTooltip='rationaleHint'
              disabled={disabled}
              error={
                siteProposalFieldValidation.details.rationaleForSiteInformation
                  ? {
                    field: '',
                    error: ''
                  }
                  : { field: 'rationaleForSiteInformation', error: 'pleaseCompleteThisField' }
              }
            />
          </Col>
        </Row>
        <Row>
          <Col md={8} mdOffset={2}>
            <Textarea
              height='96px'
              label='biodiversityValues'
              value={biodiversadditionalBiodiversityValuesityValues}
              onChange={handleBiodiversityValuesChange}
              placeholder='biodiversityValuesPlaceholder'
              infoTooltip='biodiversityValueHint'
              isOptional={true}
              disabled={disabled}
            />
          </Col>
        </Row>
        <Row>
          <Col md={8} mdOffset={2}>
            <Textarea
              height='96px'
              label='siteValues'
              value={indigenousGroups}
              onChange={handleIndigenousGroupsChange}
              placeholder='siteValuesPlaceholder'
              infoTooltip='siteValueHint'
              isOptional={true}
              disabled={disabled}
            />
          </Col>
        </Row>
      </div>
      <AssessmentTitle
        titleId='manageabilityDelineation'
        subTitleId='manageabilityDelineationDescription'
        marginTop='64px'
        fontSizePageSubtitle='14px'
      />
      <div data-test='site-manageability-delineation-form'>
        <Row>
          <Col md={8} mdOffset={2}>
            <Textarea
              height='96px'
              label='manageability'
              field='howIsTheSiteManaged'
              value={howIsTheSiteManaged}
              onChange={handleManagedChange}
              placeholder='siteManagedPlaceholder'
              infoTooltip='siteManagedHint'
              disabled={disabled}
              error={
                siteProposalFieldValidation.details.howIsTheSiteManaged
                  ? { field: '', error: '' }
                  : {
                    field: 'howIsTheSiteManaged',
                    error: 'pleaseCompleteThisField'
                  }
              }
            />
          </Col>
        </Row>
        <Row>
          <Col md={8} mdOffset={2}>
            <Textarea
              height='96px'
              label='supersidedSites'
              field='supersidedSites'
              value={supersidedSites}
              onChange={handleSupersidedSitesChange}
              placeholder='supersidedSitesPlaceholder'
              infoTooltip='supersidedSitesHint'
              disabled={disabled}
              isOptional={true}
            />
          </Col>
        </Row>
        <Row>
          <Col md={8} mdOffset={2}>
            <Textarea
              height='96px'
              label='delineation'
              field='deliniationRationale'
              value={deliniationRationale}
              onChange={handleDelineationChange}
              placeholder='delineationPlaceholder'
              infoTooltip='delineationHint'
              disabled={disabled}
              error={
                siteProposalFieldValidation.details.deliniationRationale
                  ? { field: '', error: '' }
                  : {
                    field: 'deliniationRationale',
                    error: 'pleaseCompleteThisField'
                  }
              }
            />
          </Col>
        </Row>
      </div>
      <AssessmentTitle
        titleId='protectedConserved'
        subTitleId='protectedConservedDescription'
        marginTop='64px'
        fontSizePageSubtitle='14px'
      />
      <div data-test='site-protected-conserved-areas-form'>
        <Row>
          <Col md={4} mdOffset={2}>
            <Select
              label='siteCoverage'
              field='CoverageOfProtectedAreasId'
              options={siteCoverage}
              value={CoverageOfProtectedAreasId}
              onChange={handleCoverageChange}
              height='48px'
              placeholder='siteCoveragePlaceholder'
              menuPlacement='bottom'
              dataTest='form-field'
              infoTooltip='siteCoverageHint'
              disabled={disabled}
              error={
                siteProposalFieldValidation.details.CoverageOfProtectedAreasId
                  ? { field: '', error: '' }
                  : {
                    field: 'CoverageOfProtectedAreasId',
                    error: 'pleaseCompleteThisField'
                  }
              }
            />
          </Col>
          <Col md={4}>
            {CoverageOfProtectedAreasId?.value >= second && (
              <Textarea
                height='96px'
                label='protectedArea'
                field='coveredByWhatProtectedAreas'
                value={coveredByWhatProtectedAreas}
                onChange={handleProtectedAreaChange}
                placeholder='protectedAreaPlaceholder'
                infoTooltip='protectedAreaHint'
                disabled={disabled}
                error={
                  siteProposalFieldValidation.details.coveredByWhatProtectedAreas
                    ? { field: '', error: '' }
                    : {
                      field: 'coveredByWhatProtectedAreas',
                      error: 'pleaseCompleteThisField'
                    }
                }
              />
            )}
          </Col>
        </Row>
        <Row>
          <Col md={8} mdOffset={2}>
            <Input
              label='coveredByPa'
              field='coveredByPa'
              value={coveredByPa}
              onChange={handleCoveredByPaChange}
              placeholder='coveredByPaPlaceholder'
              dataTest='form-field'
              infoTooltip='coveredByPaHint'
              disabled={disabled}
              isOptional={true}
              hyper={'https://www.protectedplanet.net/en/thematic-areas/wdpa?tab=WDPA'}
            />
          </Col>
        </Row>
        <Row>
          <Col md={4} mdOffset={2}>
            <Select
              value={oecmDrop}
              onChange={handleChangeOecm}
              options={oecmOverlap}
              placeholder='oecmOverlapPlaceholder'
              label='coverageArea'
              field='OECMcoverageArea'
              infoTooltip='oecmDropHint'
              disabled={disabled}
              error={
                siteProposalFieldValidation.details.overlapOECMProtectedCoverage
                  ? { field: '', error: '' }
                  : {
                    field: 'OECMcoverageArea',
                    error: 'pleaseCompleteThisField'
                  }
              }
            />
          </Col>
          <Col md={4}>
            <Input
              label='coveredByOECM'
              field='coveredByOECM'
              value={coveredByOECM}
              onChange={handleCoveredByOECMChange}
              placeholder='coveredByOECMPlaceholder'
              dataTest='form-field'
              infoTooltip='coveredByOECMHint'
              disabled={disabled}
              isOptional={true}
              hyper={'https://www.protectedplanet.net/en/thematic-areas/wdpa?tab=WDPA'}
            />
          </Col>
        </Row>
      </div>
      <AssessmentTitle
        titleId='habitatsLand'
        subTitleId='habitatsLandDescription'
        marginTop='64px'
        marginBottom='56px'
        fontSizePageSubtitle='14px'
      />
      <div data-test='site-habitats-land-use-form'>
        <Row>
          <Col md={11} mdOffset={-2}>
            <Habitats site={site} disabled={editOnlySiteStatus ? true : disabled} />
          </Col>
        </Row>
        <Row>
          <Col md={8} mdOffset={2}>
            <Textarea
              height='96px'
              label='habitatDescription'
              field='habitatDescription'
              value={habitat}
              onChange={handleHabitatChange}
              placeholder='habitatPlaceholder'
              infoTooltip='habitatHint'
              isOptional={true}
              disabled={disabled}
              hyper={'https://www.iucnredlist.org/resources/habitat-classification-scheme'}
              textForLink={'IUCN Habitat Classification Scheme'}
            />
          </Col>
        </Row>
        <Row>
          <Col md={8} mdOffset={2}>
            <Textarea
              height='96px'
              label='landUse'
              value={landUseRegimesAtSite}
              onChange={handleLandUseChange}
              placeholder='landUsePlaceholder'
              infoTooltip='landUseHint'
              isOptional={true}
              disabled={disabled}
            />
          </Col>
        </Row>
      </div>
      <AssessmentTitle
        titleId='pressures'
        subTitleId='pressuresDescription'
        marginTop='64px'
        fontSizePageSubtitle='14px'
      />
      <div data-test='site-pressures-form'>
        <Row>
          <Col md={8} mdOffset={2}>
            <Textarea
              height='96px'
              label='threatsDescription'
              field='threatsDescription'
              value={threatsDescription}
              onChange={handleThreatsDescriptionChange}
              placeholder='threatsDescriptionPlaceholder'
              infoTooltip='threatsDescriptionHint'
              disabled={disabled}
              isOptional={true}
            />
          </Col>
        </Row>
      </div>
      <AssessmentTitle
        titleId='additionalDetails'
        subTitleId='additionalDetailsDescription'
        marginTop='64px'
        fontSizePageSubtitle='14px'
      />
      <div data-test='site-additional-details-form'>
        <Row>
          <Col md={8} mdOffset={2}>
            <Textarea
              height='96px'
              label='notes'
              value={notes}
              onChange={handleNotesChange}
              placeholder='notesPlaceholder'
              infoTooltip='notesHint'
              isOptional={true}
              disabled={disabled}
            />
          </Col>
        </Row>
        <Row>
          <Col md={8} mdOffset={2}>
            <Textarea
              height='96px'
              label='references'
              value={references}
              onChange={handleReferencesChange}
              placeholder='referencesPlaceholder'
              infoTooltip='referencesHint'
              isOptional={true}
              disabled={disabled}
            />
          </Col>
        </Row>
        <Row>
          <Col md={8} mdOffset={2}>
            <Textarea
              label="contributors"
              value={contributors}
              field="contributors"
              infoTooltip="contributorsHint"
              onChange={handleChangeContributors}
              placeholder="contributorsPlaceholder"
              height="128px"
              dataTest="contributors-text-area"
              isOptional={false}
              disabled={disabled}
              error={
                siteProposalFieldValidation.details.consultationWithContributors
                  ? { field: '', error: '' }
                  : {
                    field: 'contributors',
                    error: 'pleaseCompleteThisField'
                  }
              }
            />
          </Col>
        </Row>
      </div>
      <ScrollToTop bottom="104px" />
    </Container>
  )
}

export default DetailsPage
